<!-- Filter Buttons -->
<div class="filter-buttons-container d-flex align-items-center">
  <button
    class="filter-btn filter-btn-primary"
    (click)="openFilterPopup()"
    title="Filter">
    <img src="/assets/images/uploads/filter-large.svg" alt="Filter" />
  </button>
  <button
    class="filter-btn filter-btn-clear"
    [disabled]="!hasActiveFilters()"
    (click)="clearAllFilters()"
    title="Clear Filters">
    <img src="/assets/images/uploads/filter-clear.svg" alt="Clear Filters" />
  </button>
</div>

<!-- Filter Popup -->
@if (isFilterPopupVisible) {
  <div class="filter-popup-overlay" (click)="onClosePopup()">
    <div class="filter-popup-container" (click)="onPopupClick($event)">
      <div class="filter-popup-header">
        <h3 class="filter-popup-title">{{ config.title || 'Filter' }}</h3>
        <button class="filter-popup-close" (click)="onClosePopup()">
          <i class="pi pi-times"></i>
        </button>
      </div>
      <div class="filter-popup-body">
        <form class="filter-form">
          @if (isDataReady) {
            <div class="filter-fields-grid">
              <!-- Regular Fields -->
              @for (field of allFields; track trackByFieldKey($index, field)) {
                <div class="filter-field">
                  <label class="filter-field-label" [ngClass]="{ 'disabled': field.disabled }">{{ field.label }}</label>
                  <div class="filter-field-input-container">
                    <!-- Multi-select field with checkboxes -->
                    @if (field.type === 'multi-select') {
                      <div class="multi-select-container">
                        <div class="multi-select-dropdown" [class.disabled]="field.disabled">
                          <div class="multi-select-header">
                            <button
                              type="button"
                              class="multi-select-toggle"
                              [disabled]="field.disabled"
                              (click)="toggleMultiSelect(field.key); $event.stopPropagation()">
                              <span class="multi-select-text">
                                {{ getMultiSelectDisplayText(field.key) }}
                              </span>
                              <span class="multi-select-arrow">▼</span>
                            </button>
                          </div>
                          @if (isMultiSelectOpen(field.key)) {
                            <div class="multi-select-options" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                              <!-- Select All / Unselect All - Always show -->
                              <div class="multi-select-option sticky-option" (click)="onSelectAllLabelClick(field.key, $event)">
                                <label class="multi-select-option-label">
                                  <input
                                    type="checkbox"
                                    [checked]="hasOptions(field.key) && isAllSelected(field.key)"
                                    [indeterminate]="hasOptions(field.key) && isSomeSelected(field.key)"
                                    (change)="onSelectAllCheckboxChange(field.key, $event)"
                                    [disabled]="field.disabled || !hasOptions(field.key)">
                                  <span class="multi-select-option-text">
                                    {{ hasOptions(field.key) && isAllSelected(field.key) ? 'Unselect All' : 'Select All' }}
                                  </span>
                                </label>
                              </div>
                              <!-- Options -->
                              @for (option of getFieldOptions(field.key); track trackByOptionValue($index, option)) {
                                <div class="multi-select-option" (click)="toggleOptionSelection(field.key, option.value, $event)">
                                  <label class="multi-select-option-label">
                                    <input
                                      type="checkbox"
                                      [value]="option.value"
                                      [checked]="isOptionSelected(field.key, option.value)"
                                      (change)="onMultiSelectChange(field.key, option.value, $event)"
                                      [disabled]="field.disabled">
                                    <span class="multi-select-option-text">{{ option.label }}</span>
                                  </label>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                    <!-- Multi-select dropdown for all filter fields -->
                    @if (field.type === 'dropdown') {
                      <div class="multi-select-container">
                        <div class="multi-select-dropdown" [class.disabled]="field.disabled">
                          <div class="multi-select-header">
                            <button
                              type="button"
                              class="multi-select-toggle"
                              [disabled]="field.disabled"
                              (click)="toggleMultiSelect(field.key); $event.stopPropagation()">
                              <span class="multi-select-text">
                                {{ getMultiSelectDisplayText(field.key) }}
                              </span>
                              <span class="multi-select-arrow">▼</span>
                            </button>
                          </div>
                          @if (isMultiSelectOpen(field.key)) {
                            <div class="multi-select-options" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                              <!-- Select All / Unselect All - Always show -->
                              <div class="multi-select-option sticky-option" (click)="onSelectAllLabelClick(field.key, $event)">
                                <label class="multi-select-option-label">
                                  <input
                                    type="checkbox"
                                    [checked]="hasOptions(field.key) && isAllSelected(field.key)"
                                    [indeterminate]="hasOptions(field.key) && isSomeSelected(field.key)"
                                    (change)="onSelectAllCheckboxChange(field.key, $event)"
                                    [disabled]="field.disabled || !hasOptions(field.key)">
                                  <span class="multi-select-option-text">
                                    {{ hasOptions(field.key) && isAllSelected(field.key) ? 'Unselect All' : 'Select All' }}
                                  </span>
                                </label>
                              </div>
                              <!-- Options -->
                              @for (option of getFieldOptions(field.key); track trackByOptionValue($index, option)) {
                                <div class="multi-select-option" (click)="toggleOptionSelection(field.key, option.value, $event)">
                                  <label class="multi-select-option-label">
                                    <input
                                      type="checkbox"
                                      [value]="option.value"
                                      [checked]="isOptionSelected(field.key, option.value)"
                                      (change)="onMultiSelectChange(field.key, option.value, $event)"
                                      [disabled]="field.disabled">
                                    <span class="multi-select-option-text">{{ option.label }}</span>
                                  </label>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                    <!-- Text input for search fields -->
                    @if (field.type === 'text') {
                      <input
                        type="text"
                        class="filter-input"
                        [name]="field.key"
                        [disabled]="field.disabled"
                        [(ngModel)]="selectedFilters[field.key]"
                        (ngModelChange)="onFieldChange(field.key, $event)"
                        [placeholder]="field.placeholder || 'Enter search text...'">
                    }
                    <button
                      type="button"
                      class="filter-clear-btn"
                      (click)="clearField(field.key)"
                      [style.display]="hasValue(field.key) ? 'block' : 'none'"
                      title="Clear selection">
                      ×
                    </button>
                  </div>
                </div>
              }
              <!-- Visual Separator -->
              @if (allCustomFields.length > 0) {
                <div class="filter-separator">
                  <hr class="separator-line">
                  <span class="separator-text">Custom Fields</span>
                  <hr class="separator-line">
                </div>
              }
              <!-- Custom Fields -->
              @for (customField of allCustomFields; track trackByFieldKey($index, customField)) {
                <div class="filter-field">
                  <label class="filter-field-label">{{ customField.label }}</label>
                  <div class="filter-field-input-container">
                    <!-- Multi-select dropdown for custom fields -->
                    <div class="multi-select-container">
                      <div class="multi-select-dropdown">
                        <div class="multi-select-header">
                          <button
                            type="button"
                            class="multi-select-toggle"
                            (click)="toggleMultiSelect(customField.key)">
                            <span class="multi-select-text">
                              {{ getMultiSelectDisplayText(customField.key) }}
                            </span>
                            <span class="multi-select-arrow">▼</span>
                          </button>
                        </div>
                        @if (isMultiSelectOpen(customField.key)) {
                          <div class="multi-select-options" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                            <!-- Select All / Unselect All - Always show -->
                            <div class="multi-select-option sticky-option" (click)="onSelectAllLabelClick(customField.key, $event)">
                              <label class="multi-select-option-label">
                                <input
                                  type="checkbox"
                                  [checked]="hasOptions(customField.key) && isAllSelected(customField.key)"
                                  [indeterminate]="hasOptions(customField.key) && isSomeSelected(customField.key)"
                                  (change)="onSelectAllCheckboxChange(customField.key, $event)"
                                  [disabled]="!hasOptions(customField.key)">
                                <span class="multi-select-option-text">
                                  {{ hasOptions(customField.key) && isAllSelected(customField.key) ? 'Unselect All' : 'Select All' }}
                                </span>
                              </label>
                            </div>
                            <!-- Options -->
                            @for (option of getFieldOptions(customField.key); track trackByOptionValue($index, option)) {
                              <div class="multi-select-option" (click)="toggleOptionSelection(customField.key, option.value, $event)">
                                <label class="multi-select-option-label">
                                  <input
                                    type="checkbox"
                                    [value]="option.value"
                                    [checked]="isOptionSelected(customField.key, option.value)"
                                    (change)="onMultiSelectChange(customField.key, option.value, $event)">
                                  <span class="multi-select-option-text">{{ option.label }}</span>
                                </label>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <button
                      type="button"
                      class="filter-clear-btn"
                      (click)="clearField(customField.key)"
                      [style.display]="hasValue(customField.key) ? 'block' : 'none'"
                      title="Clear selection">
                      ×
                    </button>
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="filter-loading">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <p>Loading filters...</p>
            </div>
          }
        </form>
      </div>
      <div class="filter-popup-footer">
        <button type="button" class="btn btn-secondary" (click)="onResetFilters()">
          Reset
        </button>
        <button type="button" class="btn btn-secondary" (click)="onCancelFilters()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="onApplyFilters()">
          Apply
        </button>
      </div>
    </div>
  </div>
}

<!-- Loading Template -->
